import { render } from "./4.vue?vue&type=template&id=31a8b232&scoped=true"
import script from "./4.vue?vue&type=script&lang=js"
export * from "./4.vue?vue&type=script&lang=js"

import "./4.vue?vue&type=style&index=0&id=31a8b232&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a8b232"]])

export default __exports__